<script setup lang="ts">
import type {
  VoixLinkFieldInterface,
  VoixMediaFieldInterface,
  VoixTextFieldInterface,
  VoixWysiwygFieldInterface,
} from '@voix/types'

const props = defineProps<{
  fields: {
    title: VoixTextFieldInterface
    description: VoixWysiwygFieldInterface
    image: VoixMediaFieldInterface
    link: VoixLinkFieldInterface
  }
}>()

defineSlice({
  fields: {
    image: {
      type: 'media',
      label: 'Image',
      breakpoints: {
        default: {
          width: 380,
          height: 338,
        },
      },
    },
    title: { type: 'text', label: 'Title', editorLabel: true },
    description: { type: 'wysiwyg', label: 'Description' },
    link: { type: 'link', label: 'Link', enabled: false },
  },
  name: { label: 'Seadust Sandy Three Col Grid Item', group: 'Seadust', layouts: ['Seadust'] },
  templates: [
    {
      label: 'Seadust Sandy Three Col Grid Item',
      fields: {
        description: {
          value:
            '<p>Located in the lobby. Book all kinds of excursions and tours. For more information, please dial extension 6175. Opening hours are from 7:30 a.m. at 8:30 p.m.<\/p>',
        },
        image: {
          value:
            'https:\/\/playa-cms-assets.s3.amazonaws.com\/media\/seadust\/services\/family.jpeg',
        },
        title: { value: 'TRAVEL AGENCY' },
      },
    },
  ],
})

const onHover = ref(false)

function goToPage() {
  if (props.fields.link.enabled && props.fields.link.value?.href) {
    if (props.fields.link.value?.target === '_blank') {
      window.open(props.fields.link.value?.href, '_blank')
    }
    else {
      window.location.href = props.fields.link.value?.href
    }
  }
}
</script>

<template>
  <div class="w-[380px] h-full">
    <div
      class="w-[380px] h-[338px] relative"
      :class="{ 'cursor-pointer': fields.link.enabled }"
      @click="goToPage"
      @mouseover="onHover = true"
      @mouseleave="onHover = false"
    >
      <!-- Title & Description -->
      <div
        class="flex flex-col items-center justify-center absolute bottom-0 bg-color-accent duration-700 ease-in-out p-8 z-20"
        :class="{
          'h-[88px]': !onHover,
          'h-[338px]': onHover,
        }"
      >
        <div class="title text-white">
          {{ fields.title.value }}
        </div>

        <VoixWysiwyg
          class="copy !text-white !leading-snug text-center duration-700 ease-in-out mt-[0px]"
          :class="{
            'max-h-[0px] opacity-0': !onHover,
            'max-h-[338px] opacity-100 mt-[8px]': onHover,
          }"
          :field="fields.description"
        />
      </div>

      <!-- Background Image -->
      <VoixMedia
        :field="fields.image"
        class="w-full h-full object-cover absolute inset-0 z-10"
        alt="Travel agency Seadust Cancun Family. Resort"
        title="Travel agency Seadust Cancun Family. Resort"
      />
    </div>

    <VoixWysiwyg
      class="xl:hidden copy !leading-snug text-center mt-6"
      :field="fields.description"
    />
  </div>
</template>
